const convertObjToQueryStr = (data, name) => {
  const request = {};
  data.forEach((stateroom, index) => {
    Object.keys(stateroom).forEach((k) => {
      if (stateroom[k] === null || stateroom[k] === undefined) return;
      if (typeof (stateroom[k]) === 'object') {
        Object.keys(stateroom[k]).forEach((key) => {
          request[`${name}[${index}].${k}.${key}`] = stateroom[k][key];
        });
      } else {
        request[`${name}[${index}].${k}`] = stateroom[k];
      }
    });
  });
  return request;
};

export default convertObjToQueryStr;
